import * as React from "react"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	register: Function
	errors: any
}
const MafoQuestionTen: React.FC<MafoQuestionProps> = ({ register, errors }) => {
	return (
		<>
			<h3 className="mafo-headline text-left text-blue">10. Wie bist Du auf TREK aufmerksam geworden?</h3>
			<div className="mx-auto text-left lg:max-w-[100%] pt-1">
				<ElemCheckboxMafo label={<>Weil es im Laden beworben wurde auf einem Aufsteller/Display</>} className=" pb-2 text-green">
					<input type="radio" {...register("question10")} name="question10" value="a" className={"peer absolute hidden h-1 w-1 " + (errors.question10 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Im Regal war es als Neuheit gekennzeichnet</>} className=" pb-2 text-green">
					<input type="radio" {...register("question10")} name="question10" value="b" className={"peer absolute hidden h-1 w-1 " + (errors.question10 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Ich habe im Keksregal bei Biscoff Werbung für TREK Biscoff gesehen</>} className=" pb-2 text-green">
					<input type="radio" {...register("question10")} name="question10" value="c" className={"peer absolute hidden h-1 w-1 " + (errors.question10 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Ich habe es einfach so im Regal entdeckt</>} className=" pb-2 text-green">
					<input type="radio" {...register("question10")} name="question10" value="d" className={"peer absolute hidden h-1 w-1 " + (errors.question10 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Auf Social Media z.B. durch Werbung oder Influencer</>} className=" pb-2 text-green">
					<input type="radio" {...register("question10")} name="question10" value="e" className={"peer absolute hidden h-1 w-1 " + (errors.question10 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
			</div>
		</>
	)
}

export default MafoQuestionTen
